module.exports = __webpack_public_path__ + "img/pump-north-liquid.37ff635b.png";